import React, {useEffect} from 'react'
import {useMutation} from '@apollo/client'
import {Button, Modal, Spinner} from 'react-bootstrap'
import {FormattedMessage, useIntl} from 'react-intl'
import {toast} from 'react-toastify'
import {parseId} from '../../../helpers'
import {COMPLETE_POLICY} from '../../../gql/mutations/policyMutation'
import {IResCompletePolicy} from '../soldTypes'

interface IModalProps {
  id: string
  isOpen: boolean
  onClose: () => void
  refetch: () => void
}
export const ModalCompletePolicy: React.FC<IModalProps> = ({isOpen, onClose, id, refetch}) => {
  const intl = useIntl()
  const errMsg = (message: string) =>
    intl.formatMessage({id: 'common.error.withMessage', defaultMessage: 'Error: {message}'}, {message})
  const [gqlCancel, {data, loading, error}] = useMutation<IResCompletePolicy>(COMPLETE_POLICY)

  useEffect(() => {
    if (error) toast.error(errMsg(error.message))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])

  useEffect(() => {
    if (!data) return

    if (data && data.completePolicy.success) {
      toast.success(
        intl.formatMessage({
          id: 'policies.detail.modal.complete.toast.success',
          defaultMessage: 'Policy completed successfully',
        })
      )
      refetch()
      onClose()
    } else if (data.completePolicy.errors && data.completePolicy.errors.length > 0) {
      toast.error(errMsg(data.completePolicy.errors[0].message))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const handleDelete = () => {
    gqlCancel({
      variables: {
        id: parseId(id),
      },
    })
  }
  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          <FormattedMessage
            id='policies.detail.modal.complete.title'
            defaultMessage='Complete policy'
          />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4 className='fs-2'>
          <FormattedMessage
            id='policies.detail.modal.complete.body'
            defaultMessage='Are you sure you want to mark this policy as completed?'
          />
        </h4>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClose}>
          <FormattedMessage id='common.action.cancel' defaultMessage='Cancel' />
        </Button>
        <Button variant='success' onClick={handleDelete} disabled={loading}>
          {loading && <Spinner animation='border' size='sm' className='me-2' />} <FormattedMessage
            id='policies.detail.modal.complete.confirm'
            defaultMessage='Complete'
          />
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
